export default __webpack_public_path__ + "static/media/thumbnail.e087447e.png";